export default (state, action) =>
    Object.assign({}, state, {
        header: state.header.map((header) => {
            if (header.sortLink) {
                return Object.assign({}, header, {
                    sortOrder: (header.name === action.columnName) ? 1 : 0
                });
            }

            return header;
        })
    });



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/reducers/toggleSortingOrder.js